// extracted by css-extract-rspack-plugin
export default {"cls1":"RecommendedPodcasts-cls1_fuH","cls2":"RecommendedPodcasts-cls2_DU6 RecommendedPodcasts-cls1_fuH"};